import styled from 'styled-components';
import {
  screenSize,
  regularFont,
  whiteColor,
  primaryColor,
  primaryActiveColor,
  primaryHoverColor,
  boldFont,
  appHeaderColor,
} from '@app/styles';

import municipalityLogoUrl from '@app/assets/images/Municipalitiesblack.svg';
import Logo from '@app/assets/images/munitechlogo.png';

type ImageProps = {
  image?: string;
  size?: string;
};
type Props = {
  resetDisabled?: boolean;
  applyDisabled?: boolean;
  active?: boolean;
};

export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.maxMobile}) {
    background: ${whiteColor};
  }
  @media (${screenSize.tablet}) {
    display: block;
  }
`;

export const MobileMunicipalityContainer = styled.div`
  display: flex;
  padding: 16px;
  background: rgb(247, 248, 249);
  border: 1px solid rgb(222, 225, 228);
  border-radius: 8px;
  margin: 16px;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-center: center;
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 190px);
    height: calc(100vh-60px);
    margin: auto;
    margin-top: 60px;
    margin-bottom: 180px;
  }
`;

export const FiltersContainer = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    padding: 40px 0px 22px 0px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
`;

export const FilterBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
`;

export const SearchBox = styled.div`
  width: 100%;
  cursor: pointer;
  input {
    border-color: #dde2eb;
  }
  @media (${screenSize.tablet}) {
    width: 260px;
  }
`;

export const ButtonsCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 170px;
    vertical-align: middle;
  }
`;
export const StatusBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 100px;
    vertical-align: middle;

    &:last-child {
      > button {
        border-radius: 0px 4px 4px 0px;
      }
    }
    &:first-child {
      > button {
        border-radius: 4px 0px 0px 4px;
      }
    }
    button {
      font-size: 14px;
      color: rgb(43, 43, 43);
      background: #f9fcfd;
      border-radius: 0px;
      border: 1px solid #dde2eb;
    }
    ${({ active }: Props) => {
      if (active) {
        return `
        button{
                background-color:${primaryColor};
                 
                color: ${whiteColor};
                &:hover {
                    background-color:${primaryHoverColor};
                   
                }
                &:active {
                    background-color:${primaryActiveColor};
                     
                }
              }
            `;
      }
    }}
  }
`;
export const StatusGroup = styled.div`
  display: flex;
  margin-right: 20px;
`;

export const GridContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  .ag-theme-alpine {
    font-family: Noto Sans;
  }
  .ag-body-viewport {
    cursor: pointer;
  }
  .ag-root-wrapper {
    border: 1px solid #dce0e8;
    border-radius: 4px;
  }
  .ag-root {
    .ag-header {
      background: #f3f7fd;
      border: 1px solid #eeeff4;
    }
    .ag-header-cell-text {
      font-size: 12px;
      color: #353954;
      opacity: 0.8;
      ${boldFont};
    }
    .ag-row {
      background-color: white !important;
      border-color: #e8ebf1;
      &:hover {
        background-color: rgb(243 247 253) !important ;
      }
    }

    .ag-cell {
      padding-top: 3px;
    }
  }
`;

export const GridBox = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;

  @media (${screenSize.tablet}) {
    width: 100%;
    height: calc(100vh - 230px);
  }
`;

export const InnerContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.tablet}) {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  }
`;

export const Header = styled.div`
  padding-bottom: 24px;
  margin-top: 140px;
`;

export const MuniciPalityHeader = styled.div`
  position: absolute;
  left: 16px;
  font-size: 16px;
  color: rgb(17, 15, 31);
  line-height: 24px;
  font-weight: 700;
`;

export const AddMunicipalityContainer = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column-reverse;
  padding: 0px 10px 20px 0px;
  height: 60px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  flex-direction: row;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const MobileCreate = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${appHeaderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: fixed;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const MobileContainer = styled.div``;

export const MunicipalityContainer = styled.div`
  overflow-y: auto;
  height: calc(100vh - 140px);
  padding-bottom: 60px;
`;
export const MunicipalityName = styled.div`
  font-size: 16px;
  color: rgb(17, 15, 31);
  line-height: 24px;
  font-weight: 700;
`;

export const MunicipalityAddress = styled.div`
  padding-top: 3px;
  font-size: 15px;
  color: rgb(101, 106, 116);
  line-height: 30px;
`;
export const MunicipalityValues = styled.div`
  padding-top: 3px;
  font-size: 16px;
  color: rgb(17, 15, 31);
  line-height: 30px;
`;

export const MunicipalityStatus = styled.div`
  position: absolute;
  right: 16px;
  display: flex;
  align-items: center;
`;

export const StatusDropdown = styled.div`
  position: absolute;
  z-index: 2;
  right: 30px;
  top: 110px;
  background: ${whiteColor};
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 11px 20px 0 rgb(47 54 65 / 50%);
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const NoMunicipalities = styled.div`
  font-size: 18px;
  text-align: center;
  height: calc(100vh - 140px);
  line-height: calc(100vh - 140px);
`;

export const StatusOption = styled.div`
  font-size: 18px;
  display: block;
  color: #100f1f;
  opacity: 1;
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 6px;
  line-height: 26px;
`;

export const MobileOptions = styled.div`
  position: fixed;
  background: #ffffff;
  z-index: 3;
  height: auto;
  top: 100px;
  right: 15px;
  border: 1px solid #dce0e8;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 11px 20px 0 rgb(47 54 65 / 50%);
  @media (${screenSize.tablet}) {
    right: 30px;
    top: 110px;
  }
  @media (${screenSize.desktop}) {
    display: none;
  }
`;

export const MunicipalityIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${municipalityLogoUrl});
  ${({ image }: ImageProps) => {
    if (image) {
      return `background-image:url(${image});
          `;
    } else {
      return `background-image: url(${municipalityLogoUrl});`;
    }
  }}
`;

export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;

export const MuncipalityName = styled.p`
  font-size: 14px;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 10;
  position: absolute;
  height: calc(100% - 50px);
  background: #f8f8f8;
  top: 50px;
  border: 1px solid #bbbfc7;
`;

export const RowDataLoader = styled.span``;

export const Pagination = styled.div`
  .pagination {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    list-style-type: none;
    padding-inline-start: 0px;
    height: 50px;
    background-color: #f9fcfd;
    border-radius: 4px;
    border: 1px solid #bbbfc7;
    font-size: 15px;
    ${regularFont};
  }
  .nextLinkClassName {
    border-left: 1px solid #bbbfc7;
    width: 100px;
    height: 50px;
    display: flex;
    justify-content: center;
    padding-top: 15px;
    cursor: pointer;
    &:hover {
      outline: none;
      background-color: ${primaryHoverColor};
      color: white;
    }
    &:active,
    &:focus {
      outline: none;
      background-color: ${primaryColor};
      color: white;
    }
  }
  .previousLinkClassName {
    border-right: 1px solid #bbbfc7;
    width: 100px;
    height: 50px;
    display: flex;
    justify-content: center;
    padding-top: 15px;
    cursor: pointer;
    &:hover {
      outline: none;
      background-color: ${primaryHoverColor};
      color: white;
    }
    &:active,
    &:focus {
      outline: none;
      background-color: ${primaryColor};
      color: white;
    }
  }
  .activeLinkClassName {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #76abdf;
    border: 1px solid #bbbfc7;
    cursor: pointer;
    &:hover {
      outline: none;
      background-color: ${primaryHoverColor};
      color: white;
    }
    &:active,
    &:focus {
      outline: none;
      background-color: ${primaryColor};
      color: white;
    }
  }
  .pageLinkClassName {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      outline: none;
      background-color: ${primaryHoverColor};
      color: white;
    }
    &:active,
    &:focus {
      outline: none;
      background-color: ${primaryColor};
      color: white;
    }
  }
  .selected {
    color: white;
  }
  .disabledClassName {
    pointer-events: none;
    cursor: none;
    background-color: white;
    height: 50px;
    border-top: 1px solid #bbbfc7;
    border-bottom: 1px solid #bbbfc7;
  }
`;
